import React, { useState } from 'react';
import {
  Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink,
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';

const NavAdmin = () => (
  <NavItem>
    <NavLink href="/admin">Admin</NavLink>
  </NavItem>
);

const NavStickers = () => (
  <NavItem>
    <NavLink href="/moderate/stickers">Stickers</NavLink>
  </NavItem>
);

const NavPremiumGifs = () => (
  <NavItem>
    <NavLink href="/moderate/premium_gifs">Premium gifs</NavLink>
  </NavItem>
);

const NavTags = () => (
  <NavItem>
    <NavLink href="/tags">Tags</NavLink>
  </NavItem>
);

const NavTemplates = () => (
  <NavItem>
    <NavLink href="/templates/create">Submit Template</NavLink>
  </NavItem>
);

const NavTemplatesManager = () => (
  <NavItem>
    <NavLink href="/templates/manage">Templates Manager</NavLink>
  </NavItem>
);

const NavChannels = () => (
  <NavItem>
    <NavLink href="/channels">Channels Manager</NavLink>
  </NavItem>
);

const NavManager = () => (
  <NavItem>
    <NavLink href="/manager">Manager</NavLink>
  </NavItem>
);

const NavLovepix = () => (
  <NavItem>
    <NavLink href="/lovepix/send_photo">Lovepix</NavLink>
  </NavItem>
);

const NavLovepixOTA = () => (
  <NavItem>
    <NavLink href="/lovepix/ota">OTA</NavLink>
  </NavItem>
);

const NavAmbassador = () => (
  <NavItem>
    <NavLink href="/ambassador">Ambassador</NavLink>
  </NavItem>
);

const NavUserInfo = () => (
  <NavItem>
    <NavLink href="/user">User Info</NavLink>
  </NavItem>
);

const NavPhotoBookInfo = () => (
  <NavItem>
    <NavLink href="/photobook">Photo Book Info</NavLink>
  </NavItem>
);

const NavPhotoBookManager = () => (
  <NavItem>
    <NavLink href="/photobook/manage">Photo Book Manager</NavLink>
  </NavItem>
);

const NavLovebobxInfo = () => (
  <NavItem>
    <NavLink href="/lovebox">Lovebox Info</NavLink>
  </NavItem>
);

const NavKeepInfo = () => (
  <NavItem>
    <NavLink href="/keep">KEEP Info</NavLink>
  </NavItem>
);

const NavKeepDashboard = () => (
  <NavItem>
    <NavLink href="/keep/dashboard">KEEP Dashboard</NavLink>
  </NavItem>
);

const NavLogged = ({ token, logEmail, onLogout }) => (
  <div>
    {token && (
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret>
          {logEmail}
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={onLogout}>
            Déconnexion
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    )}
  </div>
);

const Navigation = ({
  logEmail, token, onLogout, roles,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <Navbar color="light" light expand="md">
        <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto" navbar>
            {roles.savagent && <NavUserInfo />}
            {roles.savagent && <NavPhotoBookInfo />}
            {roles.savagent && <NavPhotoBookManager />}
            {roles.savagent && <NavLovebobxInfo />}
            {roles.savagent && <NavKeepInfo />}
            {roles.savagent && <NavKeepDashboard />}
            {roles.ota && <NavLovepixOTA />}
            {roles.lovepix && <NavLovepix />}
            {roles.admin && <NavStickers />}
            {(roles.admin || roles.designer) && <NavPremiumGifs />}
            {roles.admin && <NavTags />}
            {roles.designer && !roles.templatesManager && <NavTemplates />}
            {roles.templatesManager && <NavTemplatesManager />}
            {roles.templatesManager && <NavChannels />}
            {roles.manager && <NavManager />}
            {roles.ambassador && <NavAmbassador />}
            {roles.admin && <NavAdmin />}
            <NavLogged token={token} logEmail={logEmail} onLogout={onLogout} />
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.js